(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('WarningCategory', WarningCategory);

    WarningCategory.$inject = ['$resource'];

    function WarningCategory ($resource) {
        var resourceUrl =  'api/warning-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
